export function stripUrlProtocol(url) {
    return (url || "").replace(/^https?:\/\//, "");
}

// Esquema explícito ("https://", "http://") o uno sin barras que sí se usa
// en links (mailto:, tel:, sms:, whatsapp:).
const URL_SCHEME_REGEX =
    /^([a-z][a-z0-9+.-]*:\/\/|(mailto|tel|sms|whatsapp):)/i;

// Los usuarios suelen escribir solo "mipagina.com": si la URL no trae
// esquema se le antepone "https://". Rutas internas ("/producto") quedan
// igual.
export function ensureUrlProtocol(url) {
    const value = (url || "").trim();
    if (!value || value.startsWith("/") || URL_SCHEME_REGEX.test(value)) {
        return value;
    }
    return `https://${value.replace(/^\/+/, "")}`;
}
